import axios from '@/axios';
import _ from 'lodash';
//import { sync } from 'vuex-router-sync';

//sync(store, router);

let accessToken = localStorage.accessToken;
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

const cacheExpiry = 0 * 1000; // for development, no cache at all 

export default {

  namespaced: true,

  actions: {

    async teamList ( {state, commit, rootState}, payload ) {
      let notExpired = (await state.cache_expiry) > (new Date);
      let notEmpty = !_.isEmpty(await state.teams);

      //var organization_id=state.user.id;
      var organization_id=rootState.user.current_organization;

      if (notExpired && notEmpty) return;

      try {
        let res = await axios.get('/organization/'+organization_id+'/member');
        commit('UPDATE_FORMS', res.data.data);
        //TODO: split by organization ?
      } catch (e) {
        throw e;
      }
    },
    async validateFPXOrder ({ commit }, payload){
      return await axios.post('/stripe/validateFPXOrder', payload)
        .then((res) => {
          return res.data.data;
        })
        .catch((err) => { console.log(err)})
    },
  },

  getters: {

    layoutNames () {
      return [ 'Dropdown', 'Grid', 'Card' ];
    }, 

  },

  mutations: {

    UPDATE_FORMS (state, payload) {
      state.teams = payload;
      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    UPDATE_FORM (state, payload) {

      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    CREATE_FORM (state, payload) {

      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    REMOVE_FORM (state, form_id) {
      state.teams = state.forms.filter(x => x.id !== form_id);
      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    REMOVE_FORMS (state, form_ids) {
      state.teams = state.forms.filter(x => form_ids.indexOf(x.id) < 0);
      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    SET_CURRENT_FORM(state, payload) {
      state.current_team = payload;
    },

  },

  state: {
    teamList: [],
    teams:[],
    cache_expiry: new Date(),
    current_team: {},
  }
}
